import { MoreHorizontal } from "lucide-react";
import { Button as AriaButton, Menu, MenuItem, MenuTrigger, Popover, type Key } from "react-aria-components";
import { useIntl } from "react-intl";
import { cx } from "../cx.js";
import styles from "./Menu.module.css";

export interface MenuAction {
  id: string;
  label: string;
  danger?: boolean;
  isDisabled?: boolean;
}

/** Aktionsmenü je Tabellenzeile (hält Tabellen ruhig, gefährliche Aktionen rot abgesetzt). */
export function ActionMenu({
  label,
  actions,
  onAction,
}: {
  label: string;
  actions: MenuAction[];
  onAction: (id: string) => void;
}) {
  const intl = useIntl();
  return (
    <MenuTrigger>
      <AriaButton
        className={styles.trigger}
        aria-label={intl.formatMessage({ id: "common.actionsFor" }, { name: label })}
      >
        <MoreHorizontal aria-hidden="true" />
      </AriaButton>
      <Popover className={styles.popover} placement="bottom end" offset={4}>
        <Menu
          className={styles.menu}
          onAction={(k: Key) => onAction(String(k))}
          disabledKeys={actions.filter((a) => a.isDisabled).map((a) => a.id)}
        >
          {actions.map((a) => (
            <MenuItem key={a.id} id={a.id} className={cx(styles.item, a.danger && styles.danger)}>
              {a.label}
            </MenuItem>
          ))}
        </Menu>
      </Popover>
    </MenuTrigger>
  );
}
